<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới nhóm tài sản</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitLevelFeedback"
                                                  v-model="$v.assetType.syncSourceType.$model"
                                                  :state="$v.assetType.syncSourceType.$dirty ? !$v.assetType.syncSourceType.$error : null"></b-form-input>
                                    <sync-data-source :cached="true" v-model="assetType.syncSourceType" :excluded="[2]"></sync-data-source>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn phần mềm đồng bộ
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <!--cây phân loại tài sản-->
                            <b-col sm="6">
                                <b-form-group label="Cây phân loại tài sản:"
                                              label-for="assetTypeTree2"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitTypeFeedback"
                                                  v-model="$v.assetType.treeId.$model"
                                                  :state="$v.assetType.treeId.$error ? false : null"></b-form-input>
                                    <select2 v-if="assetTypeTrees.length > 0" :options="assetTypeTrees"
                                             v-model="assetType.treeId"
                                             placeholder="--- Chọn ---"
                                             :allowClear="false"
                                             style="width:100%"> </select2>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn cây phân loại tài sản
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị áp dụng:"
                                              :label-cols-md="4"
                                              label-align="left"
                                              :horizontal="true"
                                              :label-class="isAdmin ? '' : 'required'">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitIdFeedback"
                                                  v-model="$v.assetType.unitId.$model"
                                                  :state="$v.assetType.unitId.$error ? false : null"></b-form-input>
                                    <unit-tree v-model="$v.assetType.unitId.$model" ref="unitTree"
                                               aria-describedby="unitIdFeedback"
                                               :placeholder="isAdmin ? '--- Toàn hệ thống ---' : '--- Chọn đơn vị ---'"
                                               :state="$v.assetType.unitId.$dirty? !$v.assetType.unitId.$error : null"></unit-tree>
                                    <b-form-invalid-feedback id="unitIdFeedback">
                                        Vui lòng chọn đơn vị
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Nhóm tài sản lớn:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitIdFeedback"
                                                  v-model="$v.assetType.assetTypeGroupId.$model"
                                                  :state="$v.assetType.assetTypeGroupId.$error ? false : null"></b-form-input>
                                    <treeselect id="input-parentname" :disabled="assetType.parentId > 0"
                                                ref="assetTypeGroupTree"
                                                v-model="assetType.assetTypeGroupId"
                                                :max-height="390"
                                                placeholder="Nhập tên nhóm tài sản lớn"
                                                :options="assetTypeGroups" />
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn nhóm tài sản lớn
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Nhóm tài sản cha:"
                                              label-for="input-parentname"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="unitTypeFeedback"
                                                  v-model="assetType.treeId"></b-form-input>
                                    <treeselect id="input-parentname"
                                                ref="assetTypeTree"
                                                v-model="assetType.parentId"
                                                :max-height="390"
                                                placeholder="Nhập tên nhóm tài sản"
                                                :options="assetTypes" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Mã nhóm tài sản:"
                                              label-for="input-code"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text"
                                                  aria-describedby="codeFeedback"
                                                  id="input-code"
                                                  v-model="$v.assetType.code.$model"
                                                  :state="($v.assetType.code.$dirty? !$v.assetType.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.assetType.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="($v.codeUnique.$error)">
                                        Mã nhóm tài sản đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tên nhóm tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text"
                                                  aria-describedby="nameFeedback"
                                                  id="input-name"
                                                  v-model="$v.assetType.name.$model"
                                                  :state="($v.assetType.name.$dirty? !$v.assetType.name.$error : null) && ($v.nameUnique.$dirty? !$v.nameUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback" v-if="$v.assetType.name.$error">
                                        Vui lòng nhập tên nhóm tài sản
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.assetType.name.$error && $v.nameUnique.$error">
                                        Tên nhóm tài sản đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Mô tả:"
                                              label-for="textarea-description"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text"
                                                  id="textarea-description"
                                                  v-model="assetType.description">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị tính:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text"
                                                  v-model="assetType.calculationUnit">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Ngày bắt đầu:"
                                              label-for="input-startdate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="date" style="display: none"
                                                  id="input-startdate"
                                                  v-model="assetType.startDate">
                                    </b-form-input>
                                    <date-picker v-model="assetType.startDate" class="mx-datepicker" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Ngày kết thúc:"
                                              label-for="input-enddate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.checkEndDate.$model"
                                                  :state="$v.checkEndDate.$dirty && $v.checkEndDate.$model == '' ? !$v.checkEndDate.$error : null"></b-form-input>
                                    <date-picker v-model="assetType.endDate" class="mx-datepicker" placeholder="dd/mm/yyyy"></date-picker>
                                    <b-form-invalid-feedback>
                                        Ngày kết thúc không được nhỏ hơn ngày bắt đầu
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Thời hạn sử dụng khấu hao (tháng):"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="number" min="0"
                                                  v-model="assetType.depreciationPeriod">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tỷ lệ khấu hao:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="number" min="0" step="0.001"
                                                  v-model="assetType.depreciationRate">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Thời hạn sử dụng hao mòn (năm):"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="number" min="0"
                                                  v-model="assetType.amortizationPeriod">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tỷ lệ hao mòn:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="number" min="0" step="0.001"
                                                  v-model="assetType.amortizationRate">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="text-center">
                            <b-button type="submit" variant="primary">Lưu</b-button>
                            <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, requiredIf } from 'vuelidate/lib/validators'

    export default {
        name: 'CreateAssetType',
        mixins: [validationMixin, mixins],
        data() {
            return {
                codeUnique: 'ok',
                nameUnique: 'ok',
                checkEndDate: 'ok',
                assetType: {
                    assetTypeGroupId: null,
                    parentId: null,
                    name: null,
                    code: null,
                    description: null,
                    startDate: null,
                    endDate: null,
                    //cây phân loại tài sản
                    treeId: null,
                    unitId: null,
                    depreciationPeriod: null,
                    depreciationRate: null,
                    amortizationPeriod: null,
                    amortizationRate: null,
                    calculationUnit: null,
                    syncSourceType: null,
                },

                editing: false,
            }
        },
        computed: {
            ...mapState({
                //cây phân loại tài sản
                assetTypeTrees: (state, getters) => state.common.assetTypeTrees,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                //nhóm tài sản
                //assetTypes: (state, getters) => getters.assetTypeTreeFull
            }),
            //cây phân loại tài sản
            assetTypes() {
                this.assetType.parentId = null;
                return this.$store.getters.getAssetTypeByTreeId(this.assetType.treeId || -1)
            }
        },
        watch: {
            'assetType.parentId'(newVal) {
                var node = this.$store.getters.getAssetTypeByTreeCode(newVal);
                this.assetType.code = node.code;
                this.assetType.assetTypeGroupId = node.assetTypeGroupId;
            }
        },
        validations: {
            assetType: {
                //parentId: { required },
                syncSourceType: { required },
                name: { required },
                code: { required },
                //cây phân loại tài sản
                treeId: { required },
                assetTypeGroupId: { required },
                unitId: {
                    required: requiredIf(function () {
                        return !this.isAdmin;
                    })
                }
            },
            codeUnique: { required },
            nameUnique: { required },
            checkEndDate: { required }
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                var vm = this;

                var assetType = vm.$store.getters.checkExistingAssetTypeName(undefined, this.assetType.treeId, this.assetType.parentId || '', this.assetType.name || '');
                if (assetType) {
                    this.nameUnique = "";
                } else {
                    this.nameUnique = "required"
                }
                if (this.assetType.startDate && this.assetType.startDate > this.assetType.endDate) {
                    vm.checkEndDate = "";
                }
                else {
                    vm.checkEndDate = "ok";
                }
                var vm = this;
                if (vm.assetType.code != '' && vm.assetType.code != null) {
                    vm.$services.get(`master-data/existing-asset-types-code`, { parentId: vm.assetType.parentId || '', id: vm.assetType.id || '', code: vm.assetType.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.post('master-data/asset-types', vm.assetType).done((id) => {
                                    vm.$toastr.s('Tạo mới nhóm tài sản thành công');

                                    vm.$store.dispatch('loadAssetTypes').done(() => vm.cancel());
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .mx-datepicker {
        width: 100%;
    }
</style>
